export const getDateTimeRecord = () => {
  const UTC = new Date().toISOString();
  let offset: string | number = -(new Date().getTimezoneOffset() / 60);
  if (offset >= 0) offset = "+" + offset;
  else offset = offset.toString();
  return {
    utc: UTC,
    tz: offset,
  };
};
